export const PAGINATION_STEPS = [10, 20, 50, 100];

export const getFilterOptions = <Type>(list: Type[], fieldName: keyof Type) => {
  const options = Array.from(new Set(list.flatMap((item) => item[fieldName]))).filter(Boolean);

  return options.map((option) => ({
    label: String(option),
    value: String(option),
  }));
};
